/**
 * Public API for page-wide ad auto-refresh control.
 */
export function refreshMixin(ConcertAds) {
  /**
   * Turn off ad auto-refresh for every slot on the page. Sets the
   * `disableRefreshing` setting that {@link GamAdSlot} re-checks inside its
   * refresh timer before requesting an ad, so a refresh already queued when
   * this is called is skipped rather than fired.
   */
  ConcertAds.prototype.pauseAutoRefresh = function() {
    this.settings.disableRefreshing = true;
  };
}
